var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/createDynamicJourneyRenderer.tsx
import React from "react";
import { v4 as uuidv4 } from "uuid";

// src/elementPluginsExecutor.ts
var elementPluginsExecutor = (plugins, Element, context, initialSetup) => Object.entries(plugins).filter(([key]) => Object.keys(context).includes(key) && key !== "__props").reduce((alteredElement, [, plugin]) => {
  return plugin(context, alteredElement, initialSetup);
}, Element);
var elementPluginsExecutor_default = elementPluginsExecutor;

// src/propsPluginsExecutor.ts
var propsPluginsExecutor = (propsPlugin, Element, context, initialSetup) => Array.isArray(propsPlugin) ? propsPlugin.reduce((total, plugin) => plugin(__spreadProps(__spreadValues({}, context), { __props: total }), Element, initialSetup), context.__props || {}) : propsPlugin(context, Element, initialSetup);
var propsPluginsExecutor_default = propsPluginsExecutor;

// src/createDynamicJourneyRenderer.tsx
function createDynamicJourneyRenderer({
  registry,
  plugins = {}
}) {
  const {
    initialSetup = {},
    preRender = {},
    propsPlugin,
    primitivePlugin
  } = plugins;
  return function render(context) {
    initialSetup.render = render;
    if (typeof context === "string" || typeof context === "number" || typeof context === "boolean") {
      if (primitivePlugin) {
        return primitivePlugin(context, initialSetup);
      }
      return context;
    }
    const { __component, __props = {}, __returnFunction = false } = context;
    let Element = registry[__component] || __component;
    Element = elementPluginsExecutor_default(preRender, Element, context, initialSetup);
    const _a = propsPlugin ? propsPluginsExecutor_default(propsPlugin, Element, context, initialSetup) : __props, { children = __props.children } = _a, props = __objRest(_a, ["children"]);
    if (!__component) {
      return props;
    }
    const returnedElement = (() => {
      if (typeof children === "string" || typeof children === "number" || typeof children === "boolean" || !Array.isArray(children) && children && !!children.__component) {
        return /* @__PURE__ */ React.createElement(Element, __spreadValues({
          key: uuidv4()
        }, props), render(children));
      }
      if (Array.isArray(children) && !!children.length) {
        return /* @__PURE__ */ React.createElement(Element, __spreadValues({
          key: uuidv4()
        }, props), children.map(render));
      }
      return /* @__PURE__ */ React.createElement(Element, __spreadValues({
        key: uuidv4()
      }, props));
    })();
    if (__returnFunction) {
      return () => returnedElement;
    }
    return returnedElement;
  };
}

// src/index.ts
var src_default = createDynamicJourneyRenderer;
export {
  src_default as default
};
